import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=77942bfc&scoped=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js"

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=77942bfc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77942bfc"]])

export default __exports__